import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import images from "../../../../../../../../utilities/images/images";
import "./HandbookCart.scss";
import useGetCartProducts from "../../hooks/cart_products/useGetCartProducts";
import saveTransactionAction from "../../../../../../../../redux/handbook_payment_gateway/action";

const HandbookCart = ({ token, tokenType, setTabAction }) => {
  const history = useHistory();
  const { cartProducts } = useGetCartProducts({ token, tokenType });

  // ✅ When clicking the cart image → fromCart: true
  const handleCartIconClick = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    setTabAction("cart");
    history.push({
      pathname: "/handbook/cart-list",
      state: { fromCart: true },
    });
  };

  // ✅ When clicking anywhere else → fromCart: false
  const handleRedirectCartPage = () => {
    setTabAction("cart");
    history.push({
      pathname: "/handbook/cart-list",
      state: { fromCart: false },
    });
  };

  return (
    <div className="cart_count_container" onClick={handleRedirectCartPage}>
      <div className="cart_img">
        <img
          src={images.handbookCart}
          alt="cart-icon"
          onClick={handleCartIconClick} // ✅ Only this sets fromCart: true
        />
        <div className="cart_count">{cartProducts?.length}</div>
      </div>

      <div className="my_cart_text">My Cart</div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.authToken,
  tokenType: state.auth.tokenType,
});

const mapDispatchToProps = (dispatch) => ({
  setTabAction: (payload) => {
    dispatch(saveTransactionAction.setTab(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HandbookCart);
